import { render } from "./NotFound.vue?vue&type=template&id=6e2a2850&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=6e2a2850&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/51/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2a2850"]])

export default __exports__